export const countries = {
	en: [
		{value: "ES", label: "Spain"},
		{value: "US", label: "United States"},
		{value: "AF", label: "Afghanistan"},
		{value: "AX", label: "Åland Islands"},
		{value: "AL", label: "Albania"},
		{value: "DZ", label: "Algeria"},
		{value: "AS", label: "American Samoa"},
		{value: "AD", label: "Andorra"},
		{value: "AO", label: "Angola"},
		{value: "AI", label: "Anguilla"},
		{value: "AQ", label: "Antarctica"},
		{value: "AG", label: "Antigua & Barbuda"},
		{value: "AR", label: "Argentina"},
		{value: "AM", label: "Armenia"},
		{value: "AW", label: "Aruba"},
		{value: "AU", label: "Australia"},
		{value: "AT", label: "Austria"},
		{value: "AZ", label: "Azerbaijan"},
		{value: "BS", label: "Bahamas"},
		{value: "BH", label: "Bahrain"},
		{value: "BD", label: "Bangladesh"},
		{value: "BB", label: "Barbados"},
		{value: "BY", label: "Belarus"},
		{value: "BE", label: "Belgium"},
		{value: "BZ", label: "Belize"},
		{value: "BJ", label: "Benin"},
		{value: "BM", label: "Bermuda"},
		{value: "BT", label: "Bhutan"},
		{value: "BO", label: "Bolivia"},
		{value: "BA", label: "Bosnia & Herzegovina"},
		{value: "BW", label: "Botswana"},
		{value: "BV", label: "Bouvet Island"},
		{value: "BR", label: "Brazil"},
		{value: "IO", label: "British Indian Ocean Territory"},
		{value: "VG", label: "British Virgin Islands"},
		{value: "BN", label: "Brunei"},
		{value: "BG", label: "Bulgaria"},
		{value: "BF", label: "Burkina Faso"},
		{value: "BI", label: "Burundi"},
		{value: "KH", label: "Cambodia"},
		{value: "CM", label: "Cameroon"},
		{value: "CA", label: "Canada"},
		{value: "CV", label: "Cape Verde"},
		{value: "BQ", label: "Caribbean Netherlands"},
		{value: "KY", label: "Cayman Islands"},
		{value: "CF", label: "Central African Republic"},
		{value: "TD", label: "Chad"},
		{value: "CL", label: "Chile"},
		{value: "CN", label: "China"},
		{value: "CX", label: "Christmas Island"},
		{value: "CC", label: "Cocos (Keeling) Islands"},
		{value: "CO", label: "Colombia"},
		{value: "KM", label: "Comoros"},
		{value: "CG", label: "Congo - Brazzaville"},
		{value: "CD", label: "Congo - Kinshasa"},
		{value: "CK", label: "Cook Islands"},
		{value: "CR", label: "Costa Rica"},
		{value: "CI", label: "C\\u00f4te d\\u2019Ivoire"},
		{value: "HR", label: "Croatia"},
		{value: "CU", label: "Cuba"},
		{value: "CW", label: "Cura\\u00e7ao"},
		{value: "CY", label: "Cyprus"},
		{value: "CZ", label: "Czechia"},
		{value: "DK", label: "Denmark"},
		{value: "DJ", label: "Djibouti"},
		{value: "DM", label: "Dominica"},
		{value: "DO", label: "Dominican Republic"},
		{value: "EC", label: "Ecuador"},
		{value: "EG", label: "Egypt"},
		{value: "SV", label: "El Salvador"},
		{value: "GQ", label: "Equatorial Guinea"},
		{value: "ER", label: "Eritrea"},
		{value: "EE", label: "Estonia"},
		{value: "SZ", label: "Eswatini"},
		{value: "ET", label: "Ethiopia"},
		{value: "FK", label: "Falkland Islands"},
		{value: "FO", label: "Faroe Islands"},
		{value: "FJ", label: "Fiji"},
		{value: "FI", label: "Finland"},
		{value: "FR", label: "France"},
		{value: "GF", label: "French Guiana"},
		{value: "PF", label: "French Polynesia"},
		{value: "TF", label: "French Southern Territories"},
		{value: "GA", label: "Gabon"},
		{value: "GM", label: "Gambia"},
		{value: "GE", label: "Georgia"},
		{value: "DE", label: "Germany"},
		{value: "GH", label: "Ghana"},
		{value: "GI", label: "Gibraltar"},
		{value: "GR", label: "Greece"},
		{value: "GL", label: "Greenland"},
		{value: "GD", label: "Grenada"},
		{value: "GP", label: "Guadeloupe"},
		{value: "GU", label: "Guam"},
		{value: "GT", label: "Guatemala"},
		{value: "GG", label: "Guernsey"},
		{value: "GN", label: "Guinea"},
		{value: "GW", label: "Guinea-Bissau"},
		{value: "GY", label: "Guyana"},
		{value: "HT", label: "Haiti"},
		{value: "HM", label: "Heard & McDonald Islands"},
		{value: "HN", label: "Honduras"},
		{value: "HK", label: "Hong Kong SAR China"},
		{value: "HU", label: "Hungary"},
		{value: "IS", label: "Iceland"},
		{value: "IN", label: "India"},
		{value: "ID", label: "Indonesia"},
		{value: "IR", label: "Iran"},
		{value: "IQ", label: "Iraq"},
		{value: "IE", label: "Ireland"},
		{value: "IM", label: "Isle of Man"},
		{value: "IL", label: "Israel"},
		{value: "IT", label: "Italy"},
		{value: "JM", label: "Jamaica"},
		{value: "JP", label: "Japan"},
		{value: "JE", label: "Jersey"},
		{value: "JO", label: "Jordan"},
		{value: "KZ", label: "Kazakhstan"},
		{value: "KE", label: "Kenya"},
		{value: "KI", label: "Kiribati"},
		{value: "KW", label: "Kuwait"},
		{value: "KG", label: "Kyrgyzstan"},
		{value: "LA", label: "Laos"},
		{value: "LV", label: "Latvia"},
		{value: "LB", label: "Lebanon"},
		{value: "LS", label: "Lesotho"},
		{value: "LR", label: "Liberia"},
		{value: "LY", label: "Libya"},
		{value: "LI", label: "Liechtenstein"},
		{value: "LT", label: "Lithuania"},
		{value: "LU", label: "Luxembourg"},
		{value: "MO", label: "Macao SAR China"},
		{value: "MG", label: "Madagascar"},
		{value: "MW", label: "Malawi"},
		{value: "MY", label: "Malaysia"},
		{value: "MV", label: "Maldives"},
		{value: "ML", label: "Mali"},
		{value: "MT", label: "Malta"},
		{value: "MH", label: "Marshall Islands"},
		{value: "MQ", label: "Martinique"},
		{value: "MR", label: "Mauritania"},
		{value: "MU", label: "Mauritius"},
		{value: "YT", label: "Mayotte"},
		{value: "MX", label: "Mexico"},
		{value: "FM", label: "Micronesia"},
		{value: "MD", label: "Moldova"},
		{value: "MC", label: "Monaco"},
		{value: "MN", label: "Mongolia"},
		{value: "ME", label: "Montenegro"},
		{value: "MS", label: "Montserrat"},
		{value: "MA", label: "Morocco"},
		{value: "MZ", label: "Mozambique"},
		{value: "MM", label: "Myanmar (Burma)"},
		{value: "NA", label: "Namibia"},
		{value: "NR", label: "Nauru"},
		{value: "NP", label: "Nepal"},
		{value: "NL", label: "Netherlands"},
		{value: "NC", label: "New Caledonia"},
		{value: "NZ", label: "New Zealand"},
		{value: "NI", label: "Nicaragua"},
		{value: "NE", label: "Niger"},
		{value: "NG", label: "Nigeria"},
		{value: "NU", label: "Niue"},
		{value: "NF", label: "Norfolk Island"},
		{value: "KP", label: "North Korea"},
		{value: "MK", label: "North Macedonia"},
		{value: "MP", label: "Northern Mariana Islands"},
		{value: "NO", label: "Norway"},
		{value: "OM", label: "Oman"},
		{value: "PK", label: "Pakistan"},
		{value: "PW", label: "Palau"},
		{value: "PS", label: "Palestinian Territories"},
		{value: "PA", label: "Panama"},
		{value: "PG", label: "Papua New Guinea"},
		{value: "PY", label: "Paraguay"},
		{value: "PE", label: "Peru"},
		{value: "PH", label: "Philippines"},
		{value: "PN", label: "Pitcairn Islands"},
		{value: "PL", label: "Poland"},
		{value: "PT", label: "Portugal"},
		{value: "PR", label: "Puerto Rico"},
		{value: "QA", label: "Qatar"},
		{value: "RE", label: "R\\u00e9union"},
		{value: "RO", label: "Romania"},
		{value: "RU", label: "Russia"},
		{value: "RW", label: "Rwanda"},
		{value: "WS", label: "Samoa"},
		{value: "SM", label: "San Marino"},
		{value: "ST", label: "S\\u00e3o Tom\\u00e9 & Pr\\u00edncipe"},
		{value: "SA", label: "Saudi Arabia"},
		{value: "SN", label: "Senegal"},
		{value: "RS", label: "Serbia"},
		{value: "SC", label: "Seychelles"},
		{value: "SL", label: "Sierra Leone"},
		{value: "SG", label: "Singapore"},
		{value: "SX", label: "Sint Maarten"},
		{value: "SK", label: "Slovakia"},
		{value: "SI", label: "Slovenia"},
		{value: "SB", label: "Solomon Islands"},
		{value: "SO", label: "Somalia"},
		{value: "ZA", label: "South Africa"},
		{value: "GS", label: "South Georgia & South Sandwich Islands"},
		{value: "KR", label: "South Korea"},
		{value: "SS", label: "South Sudan"},
		{value: "ES", label: "Spain"},
		{value: "LK", label: "Sri Lanka"},
		{value: "BL", label: "St. Barth\\u00e9lemy"},
		{value: "SH", label: "St. Helena"},
		{value: "KN", label: "St. Kitts & Nevis"},
		{value: "LC", label: "St. Lucia"},
		{value: "MF", label: "St. Martin"},
		{value: "PM", label: "St. Pierre & Miquelon"},
		{value: "VC", label: "St. Vincent & Grenadines"},
		{value: "SD", label: "Sudan"},
		{value: "SR", label: "Suriname"},
		{value: "SJ", label: "Svalbard & Jan Mayen"},
		{value: "SE", label: "Sweden"},
		{value: "CH", label: "Switzerland"},
		{value: "SY", label: "Syria"},
		{value: "TW", label: "Taiwan"},
		{value: "TJ", label: "Tajikistan"},
		{value: "TZ", label: "Tanzania"},
		{value: "TH", label: "Thailand"},
		{value: "TL", label: "Timor-Leste"},
		{value: "TG", label: "Togo"},
		{value: "TK", label: "Tokelau"},
		{value: "TO", label: "Tonga"},
		{value: "TT", label: "Trinidad & Tobago"},
		{value: "TN", label: "Tunisia"},
		{value: "TR", label: "Turkey"},
		{value: "TM", label: "Turkmenistan"},
		{value: "TC", label: "Turks & Caicos Islands"},
		{value: "TV", label: "Tuvalu"},
		{value: "UM", label: "U.S. Outlying Islands"},
		{value: "VI", label: "U.S. Virgin Islands"},
		{value: "UG", label: "Uganda"},
		{value: "UA", label: "Ukraine"},
		{value: "AE", label: "United Arab Emirates"},
		{value: "GB", label: "United Kingdom"},
		{value: "US", label: "United States"},
		{value: "UY", label: "Uruguay"},
		{value: "UZ", label: "Uzbekistan"},
		{value: "VU", label: "Vanuatu"},
		{value: "VA", label: "Vatican City"},
		{value: "VE", label: "Venezuela"},
		{value: "VN", label: "Vietnam"},
		{value: "WF", label: "Wallis & Futuna"},
		{value: "EH", label: "Western Sahara"},
		{value: "YE", label: "Yemen"},
		{value: "ZM", label: "Zambia"},
		{value: "ZW", label: "Zimbabwe"},
	],

	es: [
	{value: "AF", label: "AFGANISTAN"},
	{value: "AL", label: "ALBANIA"},
	{value: "DE", label: "ALEMANIA"},
	{value: "AD", label: "ANDORRA"},
	{value: "AO", label: "ANGOLA"},
	{value: "AI", label: "ANGUILLA"},
	{value: "AG", label: "ANTIGUA Y BARBUDA"},
	{value: "AN", label: "ANTILLAS NEERLANDESAS"},
	{value: "SA", label: "ARABIA SAUDITA"},
	{value: "DZ", label: "ARGELIA"},
	{value: "AR", label: "ARGENTINA"},
	{value: "AM", label: "ARMENIA"},
	{value: "AW", label: "ARUBA"},
	{value: "AU", label: "AUSTRALIA"},
	{value: "AT", label: "AUSTRIA"},
	{value: "AZ", label: "AZERBAIJAN"},
	{value: "BS", label: "BAHAMAS"},
	{value: "BH", label: "BAHREIN"},
	{value: "BD", label: "BANGLADESH"},
	{value: "BB", label: "BARBADOS"},
	{value: "BE", label: "BELGICA"},
	{value: "BZ", label: "BELICE"},
	{value: "BT", label: "BHUTAN"},
	{value: "BY", label: "BIELORRUSIA"},
	{value: "BO", label: "BOLIVIA"},
	{value: "BA", label: "BOSNIA-HERZEGOVINA"},
	{value: "BW", label: "BOTSWANA"},
	{value: "BR", label: "BRASIL"},
	{value: "BN", label: "BRUNEI"},
	{value: "BG", label: "BULGARIA"},
	{value: "BF", label: "BURKINA FASO"},
	{value: "BI", label: "BURUNDI"},
	{value: "CV", label: "CABO VERDE"},
	{value: "KH", label: "CAMBOYA"},
	{value: "CM", label: "CAMERUN"},
	{value: "CA", label: "CANADA"},
	{value: "TD", label: "CHAD"},
	{value: "CZ", label: "CHEQUIA"},
	{value: "CL", label: "CHILE"},
	{value: "CN", label: "CHINA"},
	{value: "CY", label: "CHIPRE"},
	{value: "VA", label: "CIUDAD DEL VATICANO"},
	{value: "CO", label: "COLOMBIA"},
	{value: "CG", label: "CONGO"},
	{value: "KP", label: "COREA NORTE"},
	{value: "KR", label: "COREA SUR"},
	{value: "CI", label: "COSTA MARFIL"},
	{value: "CR", label: "COSTA RICA"},
	{value: "HR", label: "CROACIA"},
	{value: "CU", label: "CUBA"},
	{value: "DK", label: "DINAMARCA"},
	{value: "DJ", label: "DJIBOUTI"},
	{value: "DM", label: "DOMINICA"},
	{value: "EC", label: "ECUADOR"},
	{value: "EG", label: "EGIPTO"},
	{value: "SV", label: "EL SALVADOR"},
	{value: "AE", label: "EMIRATOS ARABES UNIDOS"},
	{value: "ER", label: "ERITREA"},
	{value: "SK", label: "ESLOVAQUIA"},
	{value: "SI", label: "ESLOVENIA"},
	{value: "ES", label: "ESPAÑA"},
	{value: "US", label: "ESTADOS UNIDOS"},
	{value: "EE", label: "ESTONIA"},
	{value: "ET", label: "ETIOPIA"},
	{value: "FJ", label: "FIDJI"},
	{value: "PH", label: "FILIPINAS"},
	{value: "FI", label: "FINLANDIA"},
	{value: "FR", label: "FRANCIA"},
	{value: "GA", label: "GABON"},
	{value: "GM", label: "GAMBIA"},
	{value: "GE", label: "GEORGIA"},
	{value: "GH", label: "GHANA"},
	{value: "GR", label: "GRECIA"},
	{value: "GT", label: "GUATEMALA"},
	{value: "GW", label: "GUINEA BISSAU"},
	{value: "GN", label: "GUINEA CONAKRY"},
	{value: "GQ", label: "GUINEA ECUATORIAL"},
	{value: "GY", label: "GUYANA"},
	{value: "HT", label: "HAITI"},
	{value: "HN", label: "HONDURAS"},
	{value: "HU", label: "HUNGRIA"},
	{value: "IN", label: "INDIA"},
	{value: "ID", label: "INDONESIA"},
	{value: "IQ", label: "IRAK"},
	{value: "IR", label: "IRAN"},
	{value: "IE", label: "IRLANDA"},
	{value: "IS", label: "ISLANDIA"},
	{value: "KM", label: "ISLAS COMORES"},
	{value: "MV", label: "ISLAS MALDIVAS"},
	{value: "MH", label: "ISLAS MARSHALL"},
	{value: "MU", label: "ISLAS MAURICIO"},
	{value: "SB", label: "ISLAS SALOMON"},
	{value: "IL", label: "ISRAEL"},
	{value: "IT", label: "ITALIA"},
	{value: "JM", label: "JAMAICA"},
	{value: "JP", label: "JAPON"},
	{value: "JO", label: "JORDANIA"},
	{value: "KZ", label: "KAZAJSTAN"},
	{value: "KE", label: "KENYA"},
	{value: "KG", label: "KIRGUIZISTAN"},
	{value: "KI", label: "KIRIBATI"},
	{value: "KW", label: "KUWAIT"},
	{value: "LA", label: "LAOS"},
	{value: "LS", label: "LESOTHO"},
	{value: "LV", label: "LETONIA"},
	{value: "LB", label: "LIBANO"},
	{value: "LR", label: "LIBERIA"},
	{value: "LY", label: "LIBIA"},
	{value: "LI", label: "LIECHTENSTEIN"},
	{value: "LT", label: "LITUANIA"},
	{value: "LU", label: "LUXEMBURGO"},
	{value: "MO", label: "MACAO"},
	{value: "MK", label: "MACEDONIA"},
	{value: "MG", label: "MADAGASCAR"},
	{value: "MY", label: "MALASIA"},
	{value: "MW", label: "MALAWI"},
	{value: "ML", label: "MALI"},
	{value: "MT", label: "MALTA"},
	{value: "MA", label: "MARRUECOS"},
	{value: "MR", label: "MAURITANIA"},
	{value: "MX", label: "MEXICO"},
	{value: "FM", label: "MICRONESIA"},
	{value: "MD", label: "MOLDAVIA"},
	{value: "MC", label: "MONACO"},
	{value: "MN", label: "MONGOLIA"},
	{value: "MZ", label: "MOZAMBIQUE"},
	{value: "MM", label: "MYANMAR"},
	{value: "NA", label: "NAMIBIA"},
	{value: "NR", label: "NAURU"},
	{value: "NP", label: "NEPAL"},
	{value: "NI", label: "NICARAGUA"},
	{value: "NE", label: "NIGER"},
	{value: "NG", label: "NIGERIA"},
	{value: "NO", label: "NORUEGA"},
	{value: "NZ", label: "NUEVA ZELANDA"},
	{value: "OM", label: "OMAN"},
	{value: "NL", label: "PAISES BAJOS"},
	{value: "PK", label: "PAKISTAN"},
	{value: "PS", label: "PALESTINA"},
	{value: "PA", label: "PANAMA"},
	{value: "PG", label: "PAPUA NUEVA GUINEA"},
	{value: "PY", label: "PARAGUAY"},
	{value: "PE", label: "PERU"},
	{value: "PL", label: "POLONIA"},
	{value: "PT", label: "PORTUGAL"},
	{value: "PR", label: "PUERTO RICO"},
	{value: "QA", label: "QATAR"},
	{value: "GB", label: "REINO UNIDO"},
	{value: "CF", label: "REPUBLICA CENTROAFRICANA"},
	{value: "BJ", label: "REPUBLICA DE BENIN"},
	{value: "GD", label: "REPUBLICA DE GRANADA"},
	{value: "ME", label: "REPUBLICA DE MONTENEGRO"},
	{value: "PW", label: "REPUBLICA DE PALAOS"},
	{value: "RS", label: "REPUBLICA DE SERBIA"},
	{value: "CD", label: "REPUBLICA DEMOCRATICA DEL CONGO"},
	{value: "DO", label: "REPUBLICA DOMINICANA"},
	{value: "RE", label: "REUNION"},
	{value: "RW", label: "RWANDA"},
	{value: "RO", label: "RUMANIA"},
	{value: "RU", label: "RUSIA"},
	{value: "EH", label: "SAHARAUI"},
	{value: "WS", label: "SAMOA"},
	{value: "KN", label: "SAN CRISTOBAL Y NIEVES"},
	{value: "SM", label: "SAN MARINO"},
	{value: "PM", label: "SAN PEDRO Y MIQUELON"},
	{value: "VC", label: "SAN VICENTE Y GRANADINAS"},
	{value: "SH", label: "SANTA ELENA"},
	{value: "LC", label: "SANTA LUCIA"},
	{value: "ST", label: "SANTO TOME Y PRINCIPE"},
	{value: "SN", label: "SENEGAL"},
	{value: "SC", label: "SEYCHELLES"},
	{value: "SL", label: "SIERRA LEONA"},
	{value: "SG", label: "SINGAPUR"},
	{value: "SY", label: "SIRIA"},
	{value: "SO", label: "SOMALIA"},
	{value: "LK", label: "SRI LANKA"},
	{value: "ZA", label: "SUDAFRICANA"},
	{value: "SD", label: "SUDAN"},
	{value: "SE", label: "SUECIA"},
	{value: "CH", label: "SUIZA"},
	{value: "SR", label: "SURINAM"},
	{value: "SZ", label: "SWAZILANDIA"},
	{value: "TH", label: "TAILANDIA"},
	{value: "TZ", label: "TANZANIA"},
	{value: "TJ", label: "TAYIKISTAN"},
	{value: "TL", label: "TIMOR ORIENTAL"},
	{value: "TG", label: "TOGO"},
	{value: "TO", label: "TONGA"},
	{value: "TT", label: "TRINIDAD Y TOBAGO"},
	{value: "TN", label: "TUNEZ"},
	{value: "TM", label: "TURKMENISTAN"},
	{value: "TR", label: "TURQUIA"},
	{value: "TV", label: "TUVALU"},
	{value: "UA", label: "UCRANIA"},
	{value: "UG", label: "UGANDA"},
	{value: "UY", label: "URUGUAY"},
	{value: "UZ", label: "UZBEKISTAN"},
	{value: "VU", label: "VANUATU"},
	{value: "VE", label: "VENEZUELA"},
	{value: "VN", label: "VIETNAM"},
	{value: "YE", label: "YEMEN"},
	{value: "DJ", label: "YIBUTI"},
	{value: "ZM", label: "ZAMBIA"},
	{value: "ZW", label: "ZIMBABWE"},
	]
}

export const countriesHashMap = {
	en: {
		"ES": "Spain",
		"US": "United States",
		"AF": "Afghanistan",
		"AX": "Åland Islands",
		"AL": "Albania",
		"DZ": "Algeria",
		"AS": "American Samoa",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AQ": "Antarctica",
		"AG": "Antigua & Barbuda",
		"AR": "Argentina",
		"AM": "Armenia",
		"AW": "Aruba",
		"AU": "Australia",
		"AT": "Austria",
		"AZ": "Azerbaijan",
		"BS": "Bahamas",
		"BH": "Bahrain",
		"BD": "Bangladesh",
		"BB": "Barbados",
		"BY": "Belarus",
		"BE": "Belgium",
		"BZ": "Belize",
		"BJ": "Benin",
		"BM": "Bermuda",
		"BT": "Bhutan",
		"BO": "Bolivia",
		"BA": "Bosnia & Herzegovina",
		"BW": "Botswana",
		"BV": "Bouvet Island",
		"BR": "Brazil",
		"IO": "British Indian Ocean Territory",
		"VG": "British Virgin Islands",
		"BN": "Brunei",
		"BG": "Bulgaria",
		"BF": "Burkina Faso",
		"BI": "Burundi",
		"KH": "Cambodia",
		"CM": "Cameroon",
		"CA": "Canada",
		"CV": "Cape Verde",
		"BQ": "Caribbean Netherlands",
		"KY": "Cayman Islands",
		"CF": "Central African Republic",
		"TD": "Chad",
		"CL": "Chile",
		"CN": "China",
		"CX": "Christmas Island",
		"CC": "Cocos (Keeling) Islands",
		"CO": "Colombia",
		"KM": "Comoros",
		"CG": "Congo - Brazzaville",
		"CD": "Congo - Kinshasa",
		"CK": "Cook Islands",
		"CR": "Costa Rica",
		"CI": "C\\u00f4te d\\u2019Ivoire",
		"HR": "Croatia",
		"CU": "Cuba",
		"CW": "Cura\\u00e7ao",
		"CY": "Cyprus",
		"CZ": "Czechia",
		"DK": "Denmark",
		"DJ": "Djibouti",
		"DM": "Dominica",
		"DO": "Dominican Republic",
		"EC": "Ecuador",
		"EG": "Egypt",
		"SV": "El Salvador",
		"GQ": "Equatorial Guinea",
		"ER": "Eritrea",
		"EE": "Estonia",
		"SZ": "Eswatini",
		"ET": "Ethiopia",
		"FK": "Falkland Islands",
		"FO": "Faroe Islands",
		"FJ": "Fiji",
		"FI": "Finland",
		"FR": "France",
		"GF": "French Guiana",
		"PF": "French Polynesia",
		"TF": "French Southern Territories",
		"GA": "Gabon",
		"GM": "Gambia",
		"GE": "Georgia",
		"DE": "Germany",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GR": "Greece",
		"GL": "Greenland",
		"GD": "Grenada",
		"GP": "Guadeloupe",
		"GU": "Guam",
		"GT": "Guatemala",
		"GG": "Guernsey",
		"GN": "Guinea",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HT": "Haiti",
		"HM": "Heard & McDonald Islands",
		"HN": "Honduras",
		"HK": "Hong Kong SAR China",
		"HU": "Hungary",
		"IS": "Iceland",
		"IN": "India",
		"ID": "Indonesia",
		"IR": "Iran",
		"IQ": "Iraq",
		"IE": "Ireland",
		"IM": "Isle of Man",
		"IL": "Israel",
		"IT": "Italy",
		"JM": "Jamaica",
		"JP": "Japan",
		"JE": "Jersey",
		"JO": "Jordan",
		"KZ": "Kazakhstan",
		"KE": "Kenya",
		"KI": "Kiribati",
		"KW": "Kuwait",
		"KG": "Kyrgyzstan",
		"LA": "Laos",
		"LV": "Latvia",
		"LB": "Lebanon",
		"LS": "Lesotho",
		"LR": "Liberia",
		"LY": "Libya",
		"LI": "Liechtenstein",
		"LT": "Lithuania",
		"LU": "Luxembourg",
		"MO": "Macao SAR China",
		"MG": "Madagascar",
		"MW": "Malawi",
		"MY": "Malaysia",
		"MV": "Maldives",
		"ML": "Mali",
		"MT": "Malta",
		"MH": "Marshall Islands",
		"MQ": "Martinique",
		"MR": "Mauritania",
		"MU": "Mauritius",
		"YT": "Mayotte",
		"MX": "Mexico",
		"FM": "Micronesia",
		"MD": "Moldova",
		"MC": "Monaco",
		"MN": "Mongolia",
		"ME": "Montenegro",
		"MS": "Montserrat",
		"MA": "Morocco",
		"MZ": "Mozambique",
		"MM": "Myanmar (Burma)",
		"NA": "Namibia",
		"NR": "Nauru",
		"NP": "Nepal",
		"NL": "Netherlands",
		"NC": "New Caledonia",
		"NZ": "New Zealand",
		"NI": "Nicaragua",
		"NE": "Niger",
		"NG": "Nigeria",
		"NU": "Niue",
		"NF": "Norfolk Island",
		"KP": "North Korea",
		"MK": "North Macedonia",
		"MP": "Northern Mariana Islands",
		"NO": "Norway",
		"OM": "Oman",
		"PK": "Pakistan",
		"PW": "Palau",
		"PS": "Palestinian Territories",
		"PA": "Panama",
		"PG": "Papua New Guinea",
		"PY": "Paraguay",
		"PE": "Peru",
		"PH": "Philippines",
		"PN": "Pitcairn Islands",
		"PL": "Poland",
		"PT": "Portugal",
		"PR": "Puerto Rico",
		"QA": "Qatar",
		"RE": "R\\u00e9union",
		"RO": "Romania",
		"RU": "Russia",
		"RW": "Rwanda",
		"WS": "Samoa",
		"SM": "San Marino",
		"ST": "S\\u00e3o Tom\\u00e9 & Pr\\u00edncipe",
		"SA": "Saudi Arabia",
		"SN": "Senegal",
		"RS": "Serbia",
		"SC": "Seychelles",
		"SL": "Sierra Leone",
		"SG": "Singapore",
		"SX": "Sint Maarten",
		"SK": "Slovakia",
		"SI": "Slovenia",
		"SB": "Solomon Islands",
		"SO": "Somalia",
		"ZA": "South Africa",
		"GS": "South Georgia & South Sandwich Islands",
		"KR": "South Korea",
		"SS": "South Sudan",
		"LK": "Sri Lanka",
		"BL": "St. Barth\\u00e9lemy",
		"SH": "St. Helena",
		"KN": "St. Kitts & Nevis",
		"LC": "St. Lucia",
		"MF": "St. Martin",
		"PM": "St. Pierre & Miquelon",
		"VC": "St. Vincent & Grenadines",
		"SD": "Sudan",
		"SR": "Suriname",
		"SJ": "Svalbard & Jan Mayen",
		"SE": "Sweden",
		"CH": "Switzerland",
		"SY": "Syria",
		"TW": "Taiwan",
		"TJ": "Tajikistan",
		"TZ": "Tanzania",
		"TH": "Thailand",
		"TL": "Timor-Leste",
		"TG": "Togo",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad & Tobago",
		"TN": "Tunisia",
		"TR": "Turkey",
		"TM": "Turkmenistan",
		"TC": "Turks & Caicos Islands",
		"TV": "Tuvalu",
		"UM": "U.S. Outlying Islands",
		"VI": "U.S. Virgin Islands",
		"UG": "Uganda",
		"UA": "Ukraine",
		"AE": "United Arab Emirates",
		"GB": "United Kingdom",
		"UY": "Uruguay",
		"UZ": "Uzbekistan",
		"VU": "Vanuatu",
		"VA": "Vatican City",
		"VE": "Venezuela",
		"VN": "Vietnam",
		"WF": "Wallis & Futuna",
		"EH": "Western Sahara",
		"YE": "Yemen",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
	},
	es: {
		"AF": "AFGANISTAN", 
		"AL": "ALBANIA", 
		"DE": "ALEMANIA", 
		"AD": "ANDORRA", 
		"AO": "ANGOLA", 
		"AI": "ANGUILLA", 
		"AG": "ANTIGUA Y BARBUDA", 
		"AN": "ANTILLAS NEERLANDESAS", 
		"SA": "ARABIA SAUDITA", 
		"DZ": "ARGELIA", 
		"AR": "ARGENTINA", 
		"AM": "ARMENIA", 
		"AW": "ARUBA", 
		"AU": "AUSTRALIA", 
		"AT": "AUSTRIA", 
		"AZ": "AZERBAIJAN", 
		"BS": "BAHAMAS", 
		"BH": "BAHREIN", 
		"BD": "BANGLADESH", 
		"BB": "BARBADOS", 
		"BE": "BELGICA", 
		"BZ": "BELICE", 
		"BT": "BHUTAN", 
		"BY": "BIELORRUSIA", 
		"BO": "BOLIVIA", 
		"BA": "BOSNIA-HERZEGOVINA", 
		"BW": "BOTSWANA", 
		"BR": "BRASIL", 
		"BN": "BRUNEI", 
		"BG": "BULGARIA", 
		"BF": "BURKINA FASO", 
		"BI": "BURUNDI", 
		"CV": "CABO VERDE", 
		"KH": "CAMBOYA", 
		"CM": "CAMERUN", 
		"CA": "CANADA", 
		"TD": "CHAD", 
		"CZ": "CHEQUIA", 
		"CL": "CHILE", 
		"CN": "CHINA", 
		"CY": "CHIPRE", 
		"VA": "CIUDAD DEL VATICANO", 
		"CO": "COLOMBIA", 
		"CG": "CONGO", 
		"KP": "COREA NORTE", 
		"KR": "COREA SUR", 
		"CI": "COSTA MARFIL", 
		"CR": "COSTA RICA", 
		"HR": "CROACIA", 
		"CU": "CUBA", 
		"DK": "DINAMARCA", 
		"DM": "DOMINICA", 
		"EC": "ECUADOR", 
		"EG": "EGIPTO", 
		"SV": "EL SALVADOR", 
		"AE": "EMIRATOS ARABES UNIDOS", 
		"ER": "ERITREA", 
		"SK": "ESLOVAQUIA", 
		"SI": "ESLOVENIA", 
		"ES": "ESPAÑA", 
		"US": "ESTADOS UNIDOS", 
		"EE": "ESTONIA", 
		"ET": "ETIOPIA", 
		"FJ": "FIDJI", 
		"PH": "FILIPINAS", 
		"FI": "FINLANDIA", 
		"FR": "FRANCIA", 
		"GA": "GABON", 
		"GM": "GAMBIA", 
		"GE": "GEORGIA", 
		"GH": "GHANA", 
		"GR": "GRECIA", 
		"GT": "GUATEMALA", 
		"GW": "GUINEA BISSAU", 
		"GN": "GUINEA CONAKRY", 
		"GQ": "GUINEA ECUATORIAL", 
		"GY": "GUYANA", 
		"HT": "HAITI", 
		"HN": "HONDURAS", 
		"HU": "HUNGRIA", 
		"IN": "INDIA", 
		"ID": "INDONESIA", 
		"IQ": "IRAK", 
		"IR": "IRAN", 
		"IE": "IRLANDA", 
		"IS": "ISLANDIA", 
		"KM": "ISLAS COMORES", 
		"MV": "ISLAS MALDIVAS", 
		"MH": "ISLAS MARSHALL", 
		"MU": "ISLAS MAURICIO", 
		"SB": "ISLAS SALOMON", 
		"IL": "ISRAEL", 
		"IT": "ITALIA", 
		"JM": "JAMAICA", 
		"JP": "JAPON", 
		"JO": "JORDANIA", 
		"KZ": "KAZAJSTAN", 
		"KE": "KENYA", 
		"KG": "KIRGUIZISTAN", 
		"KI": "KIRIBATI", 
		"KW": "KUWAIT", 
		"LA": "LAOS", 
		"LS": "LESOTHO", 
		"LV": "LETONIA", 
		"LB": "LIBANO", 
		"LR": "LIBERIA", 
		"LY": "LIBIA", 
		"LI": "LIECHTENSTEIN", 
		"LT": "LITUANIA", 
		"LU": "LUXEMBURGO", 
		"MO": "MACAO", 
		"MK": "MACEDONIA", 
		"MG": "MADAGASCAR", 
		"MY": "MALASIA", 
		"MW": "MALAWI", 
		"ML": "MALI", 
		"MT": "MALTA", 
		"MA": "MARRUECOS", 
		"MR": "MAURITANIA", 
		"MX": "MEXICO", 
		"FM": "MICRONESIA", 
		"MD": "MOLDAVIA", 
		"MC": "MONACO", 
		"MN": "MONGOLIA", 
		"MZ": "MOZAMBIQUE", 
		"MM": "MYANMAR", 
		"NA": "NAMIBIA", 
		"NR": "NAURU", 
		"NP": "NEPAL", 
		"NI": "NICARAGUA", 
		"NE": "NIGER", 
		"NG": "NIGERIA", 
		"NO": "NORUEGA", 
		"NZ": "NUEVA ZELANDA", 
		"OM": "OMAN", 
		"NL": "PAISES BAJOS", 
		"PK": "PAKISTAN", 
		"PS": "PALESTINA", 
		"PA": "PANAMA", 
		"PG": "PAPUA NUEVA GUINEA", 
		"PY": "PARAGUAY", 
		"PE": "PERU", 
		"PL": "POLONIA", 
		"PT": "PORTUGAL", 
		"PR": "PUERTO RICO", 
		"QA": "QATAR", 
		"GB": "REINO UNIDO", 
		"CF": "REPUBLICA CENTROAFRICANA", 
		"BJ": "REPUBLICA DE BENIN", 
		"GD": "REPUBLICA DE GRANADA", 
		"ME": "REPUBLICA DE MONTENEGRO", 
		"PW": "REPUBLICA DE PALAOS", 
		"RS": "REPUBLICA DE SERBIA", 
		"CD": "REPUBLICA DEMOCRATICA DEL CONGO", 
		"DO": "REPUBLICA DOMINICANA", 
		"RE": "REUNION", 
		"RW": "RWANDA", 
		"RO": "RUMANIA", 
		"RU": "RUSIA", 
		"EH": "SAHARAUI", 
		"WS": "SAMOA", 
		"KN": "SAN CRISTOBAL Y NIEVES", 
		"SM": "SAN MARINO", 
		"PM": "SAN PEDRO Y MIQUELON", 
		"VC": "SAN VICENTE Y GRANADINAS", 
		"SH": "SANTA ELENA", 
		"LC": "SANTA LUCIA", 
		"ST": "SANTO TOME Y PRINCIPE", 
		"SN": "SENEGAL", 
		"SC": "SEYCHELLES", 
		"SL": "SIERRA LEONA", 
		"SG": "SINGAPUR", 
		"SY": "SIRIA", 
		"SO": "SOMALIA", 
		"LK": "SRI LANKA", 
		"ZA": "SUDAFRICANA", 
		"SD": "SUDAN", 
		"SE": "SUECIA", 
		"CH": "SUIZA", 
		"SR": "SURINAM", 
		"SZ": "SWAZILANDIA", 
		"TH": "TAILANDIA", 
		"TZ": "TANZANIA", 
		"TJ": "TAYIKISTAN", 
		"TL": "TIMOR ORIENTAL", 
		"TG": "TOGO", 
		"TO": "TONGA", 
		"TT": "TRINIDAD Y TOBAGO", 
		"TN": "TUNEZ", 
		"TM": "TURKMENISTAN", 
		"TR": "TURQUIA", 
		"TV": "TUVALU", 
		"UA": "UCRANIA", 
		"UG": "UGANDA", 
		"UY": "URUGUAY", 
		"UZ": "UZBEKISTAN", 
		"VU": "VANUATU", 
		"VE": "VENEZUELA", 
		"VN": "VIETNAM", 
		"YE": "YEMEN", 
		"DJ": "YIBUTI", 
		"ZM": "ZAMBIA", 
		"ZW": "ZIMBABWE", 
	}

}

